import { Database, Mail, BarChart3, Globe, FileText, LifeBuoy } from 'lucide-react';

// Edit this list to point at your own internal resources.
const RESOURCES = [
  { name: 'SuperOffice', desc: 'CRM', href: 'https://online.superoffice.com', icon: Database },
  { name: 'ActiveCampaign', desc: 'Marketing', href: 'https://www.activecampaign.com', icon: Mail },
  { name: 'Google Analytics', desc: 'Web-analyse', href: 'https://analytics.google.com', icon: BarChart3 },
  { name: 'Nordcad.dk', desc: 'Hjemmeside', href: 'https://www.nordcad.dk', icon: Globe },
  { name: 'Datakilder', desc: 'Dokumentation', href: 'https://docs.superoffice.com', icon: FileText },
  { name: 'Support', desc: 'Hjælp', href: 'https://www.nordcad.dk', icon: LifeBuoy },
];

/** Slim horizontal quick-links strip between the agenda/board row and the KPI grid. */
export function QuickLinks() {
  return (
    <div className="rounded-brand bg-brand-dark px-5 py-4 text-brand-cream">
      <div className="mb-3 flex items-baseline justify-between">
        <h2 className="font-heading text-sm font-semibold">Genveje</h2>
        <span className="text-[10px] uppercase tracking-[0.18em] text-brand-cream/40">Ressourcer</span>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-6">
        {RESOURCES.map((r) => (
          <a
            key={r.name}
            href={r.href}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 rounded-[12px] border border-white/10 bg-white/5 p-2.5 transition-all hover:border-brand-accent hover:bg-white/10"
          >
            <r.icon size={16} className="shrink-0 text-brand-accent" />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium">{r.name}</div>
              <div className="truncate text-[10px] uppercase tracking-wide text-brand-cream/40">{r.desc}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
